import PropTypes from "prop-types";

import { promptContainerCss } from "./WritePromptQuestion.style";

const propTypes = {
  writePromptQuestion: PropTypes.string,
  writePromptId: PropTypes.string,
};

const WritePromptQuestion = ({ writePromptQuestion, writePromptId }) => {
  return (
    <div key={writePromptId} css={promptContainerCss}>
      {writePromptQuestion}
    </div>
  );
};

WritePromptQuestion.propTypes = propTypes;

export default WritePromptQuestion;
